var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"language-toggle d-flex justify-content-end"},[_c('button',{staticClass:"btn custom-btn mx-1",on:{"click":_vm.toggleLanguage}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }